import { PropsBusinessUnitForm } from '@/domains/business-unit/entities';
import * as yup from 'yup';

export const validateBusinessUnit = (props: PropsBusinessUnitForm) => {
  const schemaBusinessUnit = yup.object().shape({
    name: yup.string().required('Name is empty').trim(),
    businessDomainId: yup.string().required('Business domain is empty').trim(),
    categoryIds: yup.array().of(yup.string()).min(1, 'Category is required'),
    childrenIds: yup.array().of(yup.string()).optional(),
    offeringProductGroupIds: yup.array().of(yup.string()).optional(),
  });

  return { schemaBusinessUnit };
};
